import type { SVGProps } from 'react';
const DawnFlagKP = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-KP_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-KP_svg__a)">
      <path fill="#1461B6" d="M0 3.2h22V0H0zM0 16h22v-3.2H0z" />
      <path fill="#fff" d="M0 12.8h22V3.2H0z" />
      <path fill="#F53846" d="M0 11.733h22V4.267H0z" />
      <path
        fill="#fff"
        d="M10.476 8c0 1.473-1.172 2.667-2.619 2.667-1.446 0-2.619-1.194-2.619-2.667s1.173-2.667 2.62-2.667L7.24 7.134l-1.874.042L6.858 8.33l-.54 1.826 1.54-1.087 1.539 1.087-.54-1.826 1.491-1.155-1.873-.042-.618-1.8c1.447 0 2.62 1.193 2.62 2.666"
      />
    </g>
  </svg>
);
export default DawnFlagKP;
